import React from "react";
import { Controller, Control } from "react-hook-form";
import { Sort } from "./sort.component";
import type { DataType } from "../../../types";

type SortControllerProps = {
  control: Control<any>; // Sort controller always uses "sort" field
  dataType: DataType;
  ascLabel?: string;
  descLabel?: string;
};

export function SortController({
  control,
  dataType,
  ascLabel,
  descLabel,
}: SortControllerProps) {
  return (
    <Controller
      name="sort"
      control={control}
      render={({ field: { onChange, value } }) => (
        <Sort
          onChange={onChange}
          direction={value}
          dataType={dataType}
          ascLabel={ascLabel}
          descLabel={descLabel}
        />
      )}
    />
  );
}
